// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.V6kqVURPCnKS2j7oXi08 {
  padding-top: 16px;
  padding-bottom: 16px
}

.af8377lwdouyOo9HQKqM {
  margin-bottom: 14px
}

.vFwd2tnWJ9kNyImRHvWX {
  border-radius: 5px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding: 1.5rem
}

.c0Hz9RemSyVqussyKmPo {
  height: 38px;
  width: 137px;
  --tw-bg-opacity: 1;
  background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1));
  font-family: Noto Sans;
  font-size: 14px;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}

.c0Hz9RemSyVqussyKmPo:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important
}

.l0nNehz8gPOui64N_7qD {
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem
}
.POkiSSI91a4o5rv3A38c {
  height: 38px !important;
  width: 18rem;
  border-radius: 5px;
  --tw-text-opacity: 1;
  color: rgb(47 47 47 / var(--tw-text-opacity, 1))
}
.JNh3uQRhHxuO5SNdmXjZ {
  overflow-x: auto;
  border-radius: 5px;
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

.JNh3uQRhHxuO5SNdmXjZ .ant-table-cell {
  font-size: 0.75rem;
  line-height: 1rem
}

.aEeN3TmAkztXRyDtYVDr {
  display: flex;
  align-items: center;
  gap: 0.125rem
}
.BIsw3Kux1YPtgyGsMsq0 {
  max-width: 243px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  --tw-text-opacity: 1;
  color: rgb(244 49 49 / var(--tw-text-opacity, 1))
}

.JNh3uQRhHxuO5SNdmXjZ .uJWEs1otNuabutPlA9Cg > tr > td:nth-child(odd) {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(247 251 253 / var(--tw-bg-opacity, 1)) !important
}
.JNh3uQRhHxuO5SNdmXjZ .uJWEs1otNuabutPlA9Cg > tr > td:nth-child(even) {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(247 251 253 / var(--tw-bg-opacity, 1)) !important
}

.OQ0nHGHng7obodw6AYNP {
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgb(242 250 254 / var(--tw-bg-opacity, 1));
  padding-top: 0.75rem;
  padding-bottom: 0.75rem
}

.CwbMTs6OBfBgKFWt0ReJ {
  margin-top: 1.5rem;
  display: grid;
  grid-template-columns: auto auto 1fr;
  align-items: flex-start;
  gap: 1rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem
}

.ug32bByvZNqVTEBtoIgw {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  text-align: center
}

.JqkMb1ZYlJMEsJoTpYx3 {
  height: 1.5rem;
  width: 1.5rem
}

.NWXaRPHs74mlOsl10EU5 {
  font-size: 12px;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(94 94 94 / var(--tw-text-opacity, 1))
}

.E_qdv4KedeLgpWMZYeiU {
  margin-top: 4px;
  display: flex;
  justify-content: flex-start;
  padding-left: 1.5rem;
  font-family: Noto Sans;
  font-size: 12px;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(0 130 202 / var(--tw-text-opacity, 1))
}

.KW7mAh8S9Jj717FAvP_G {
  display: flex;
  align-items: center;
  gap: 0.5rem
}

.WPeUsqKg4dlCzQo6fUWv {
  grid-row: span 4 / span 4;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 0.75rem
}

.io6NlK_61tlQsEtRQX_k {
  height: 38px;
  width: 155px;
  --tw-border-opacity: 1;
  border-color: rgb(0 130 202 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(0 130 202 / var(--tw-text-opacity, 1))
}

.io6NlK_61tlQsEtRQX_k:hover {
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 130 202 / var(--tw-border-opacity, 1)) !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(0 130 202 / var(--tw-text-opacity, 1)) !important
}
.vC9fVHiSNpAfMtzUBKZC {
  height: 38px;
  width: 307px;
  --tw-border-opacity: 1;
  border-color: rgb(0 130 202 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  font-family: Noto Sans;
  font-size: 14px;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(0 130 202 / var(--tw-text-opacity, 1))
}

.vC9fVHiSNpAfMtzUBKZC:hover {
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 130 202 / var(--tw-border-opacity, 1)) !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(0 130 202 / var(--tw-text-opacity, 1)) !important
}

.AKCfW0xDvXvTYqCw49iW {
  display: flex;
  flex-direction: column;
  gap: 1rem
}
.GAf3mUFppDUrYdSBsvea {
  display: flex;
  gap: 1rem
}
.Mbx93k024o_ACg_nuzGL {
  display: flex
}

.RsbZTNNBWU_5SqW5yIjg {
  margin-left: 0.5rem;
  display: flex;
  height: 34px;
  width: 34px;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background: linear-gradient(144.9deg, #ffdb52 8.6%, rgba(229, 198, 80, 0.8) 94.03%)
}

.ol91iuiAO8oFsgdujg9l {
  height: 9px;
  width: 17px
}
.A2W498rE2tcc3ctfoTsn {
  margin-left: 0.75rem;
  font-family: Noto Sans;
  font-size: 12px;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(164 133 10 / var(--tw-text-opacity, 1))
}

.tWRVEaUUcUThjqCy7YOn {
  margin-top: 0.5rem;
  margin-bottom: 0.75rem;
  margin-left: 0.75rem;
  margin-right: 0.75rem;
  display: flex;
  height: 47px;
  align-items: center;
  border-radius: 5px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 244 203 / var(--tw-bg-opacity, 1))
}

.JNh3uQRhHxuO5SNdmXjZ .ant-checkbox .ant-checkbox-inner {
  height: 15px;
  width: 15px;
  border-radius: 2px;
  --tw-border-opacity: 1 !important;
  border-color: rgb(141 141 141 / var(--tw-border-opacity, 1)) !important
}

.JNh3uQRhHxuO5SNdmXjZ .ant-checkbox-checked .ant-checkbox-inner {
  --tw-border-opacity: 1 !important;
  border-color: rgb(3 120 209 / var(--tw-border-opacity, 1)) !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1)) !important
}

.tKjeIQfCgzWMy400s48k td {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1))
}

.qFJSYWNfC7j7n98Rbzty td {
  --tw-bg-opacity: 1;
  background-color: rgb(247 251 253 / var(--tw-bg-opacity, 1))
}
`, "",{"version":3,"sources":["webpack://./src/pages/DueDiligence/DueDiligence.module.css"],"names":[],"mappings":"AACE;EAAA,iBAAgB;EAAhB;AAAgB;;AAIhB;EAAA;AAAgB;;AAIhB;EAAA,kBAAiC;EAAjC,kBAAiC;EAAjC,4DAAiC;EAAjC;AAAiC;;AAIjC;EAAA,YAAkG;EAAlG,YAAkG;EAAlG,kBAAkG;EAAlG,0DAAkG;EAAlG,sBAAkG;EAAlG,eAAkG;EAAlG,gBAAkG;EAAlG,oBAAkG;EAAlG;AAAkG;;AAIlG;EAAA,6BAAgC;EAAhC,qEAAgC;EAAhC,+BAAgC;EAAhC;AAAgC;;AAIhC;EAAA,qBAA+C;EAA/C,aAA+C;EAA/C,mBAA+C;EAA/C,yBAA+C;EAA/C;AAA+C;AAG/C;EAAA,uBAAkD;EAAlD,YAAkD;EAAlD,kBAAkD;EAAlD,oBAAkD;EAAlD;AAAkD;AAGlD;EAAA,gBAA8C;EAA9C,kBAA8C;EAA9C,6EAA8C;EAA9C,iGAA8C;EAA9C;AAA8C;;AAI9C;EAAA,kBAAc;EAAd;AAAc;;AAId;EAAA,aAAgC;EAAhC,mBAAgC;EAAhC;AAAgC;AAGhC;EAAA,gBAAoF;EAApF,gBAAoF;EAApF,uBAAoF;EAApF,mBAAoF;EAApF,oBAAoF;EAApF;AAAoF;;AAIpF;EAAA,6BAAyB;EAAzB;AAAyB;AAGzB;EAAA,6BAAyB;EAAzB;AAAyB;;AAIzB;EAAA,uBAAuC;EAAvC,kBAAuC;EAAvC,4DAAuC;EAAvC,oBAAuC;EAAvC;AAAuC;;AAIvC;EAAA,kBAAiE;EAAjE,aAAiE;EAAjE,oCAAiE;EAAjE,uBAAiE;EAAjE,SAAiE;EAAjE,oBAAiE;EAAjE;AAAiE;;AAIjE;EAAA,aAA0C;EAA1C,mBAA0C;EAA1C,WAA0C;EAA1C;AAA0C;;AAI1C;EAAA,cAAc;EAAd;AAAc;;AAId;EAAA,eAAyD;EAAzD,gBAAyD;EAAzD,oBAAyD;EAAzD;AAAyD;;AAIzD;EAAA,eAA2F;EAA3F,aAA2F;EAA3F,2BAA2F;EAA3F,oBAA2F;EAA3F,sBAA2F;EAA3F,eAA2F;EAA3F,gBAA2F;EAA3F,oBAA2F;EAA3F;AAA2F;;AAI3F;EAAA,aAA8B;EAA9B,mBAA8B;EAA9B;AAA8B;;AAI9B;EAAA,yBAAoD;EAApD,aAAoD;EAApD,uBAAoD;EAApD,yBAAoD;EAApD;AAAoD;;AAIpD;EAAA,YAAkE;EAAlE,YAAkE;EAAlE,sBAAkE;EAAlE,0DAAkE;EAAlE,kBAAkE;EAAlE,4DAAkE;EAAlE,oBAAkE;EAAlE;AAAkE;;AAIlE;EAAA,iCAAkD;EAAlD,qEAAkD;EAAlD,6BAAkD;EAAlD,uEAAkD;EAAlD,+BAAkD;EAAlD;AAAkD;AAGlD;EAAA,YAAmH;EAAnH,YAAmH;EAAnH,sBAAmH;EAAnH,0DAAmH;EAAnH,kBAAmH;EAAnH,4DAAmH;EAAnH,sBAAmH;EAAnH,eAAmH;EAAnH,gBAAmH;EAAnH,oBAAmH;EAAnH;AAAmH;;AAInH;EAAA,iCAAkD;EAAlD,qEAAkD;EAAlD,6BAAkD;EAAlD,uEAAkD;EAAlD,+BAAkD;EAAlD;AAAkD;;AAIlD;EAAA,aAA0B;EAA1B,sBAA0B;EAA1B;AAA0B;AAG1B;EAAA,aAAiB;EAAjB;AAAiB;AAGjB;EAAA;AAAW;;AAIX;EAAA,mBAA4E;EAA5E,aAA4E;EAA5E,YAA4E;EAA5E,WAA4E;EAA5E,mBAA4E;EAA5E,uBAA4E;EAA5E,kBAA4E;EAC5E;AAD4E;;AAK5E;EAAA,WAAuB;EAAvB;AAAuB;AAGvB;EAAA,oBAAiF;EAAjF,sBAAiF;EAAjF,eAAiF;EAAjF,gBAAiF;EAAjF,oBAAiF;EAAjF;AAAiF;;AAIjF;EAAA,kBAAoF;EAApF,sBAAoF;EAApF,oBAAoF;EAApF,qBAAoF;EAApF,aAAoF;EAApF,YAAoF;EAApF,mBAAoF;EAApF,kBAAoF;EAApF,kBAAoF;EAApF;AAAoF;;AAIpF;EAAA,YAAuD;EAAvD,WAAuD;EAAvD,kBAAuD;EAAvD,iCAAuD;EAAvD;AAAuD;;AAIvD;EAAA,iCAAkC;EAAlC,qEAAkC;EAAlC,6BAAkC;EAAlC;AAAkC;;AAIlC;EAAA,kBAAe;EAAf;AAAe;;AAIf;EAAA,kBAAwB;EAAxB;AAAwB","sourcesContent":[".container {\n  @apply py-[16px];\n}\n\n.customBreadCrumbs {\n  @apply mb-[14px];\n}\n\n.mainContainer {\n  @apply bg-white rounded-[5px] p-6;\n}\n\n.applyButton {\n  @apply bg-secondary text-white w-[137px] h-[38px] text-dashboardMain font-dashboardMain font-inter;\n}\n\n.applyButton:hover {\n  @apply !bg-secondary !text-white;\n}\n\n.tenantRightActions {\n  @apply flex items-center justify-end gap-3 mb-6;\n}\n.searchInput {\n  @apply rounded-[5px]  w-72 !h-[38px] text-gray-500;\n}\n.tableWrapper {\n  @apply shadow-md rounded-[5px] overflow-x-auto;\n}\n\n.tableWrapper :global(.ant-table-cell) {\n  @apply text-xs;\n}\n\n.pledgeCell {\n  @apply flex items-center gap-0.5;\n}\n.pledgeText {\n  @apply whitespace-nowrap overflow-hidden text-ellipsis max-w-[243px] text-danger-100;\n}\n\n.tableWrapper .ant-table-tbody > tr > td:nth-child(odd) {\n  @apply !bg-tableEvenRowBG;\n}\n.tableWrapper .ant-table-tbody > tr > td:nth-child(even) {\n  @apply !bg-tableEvenRowBG;\n}\n\n.expandableBG {\n  @apply bg-tableExpandBG rounded-md py-3;\n}\n\n.totalItems {\n  @apply grid grid-cols-[auto_auto_1fr] gap-4 items-start px-6 mt-6;\n}\n\n.months {\n  @apply flex items-center text-center gap-2;\n}\n\n.expandIcon {\n  @apply w-6 h-6;\n}\n\n.labelTitle {\n  @apply text-gray-600 font-dashboardMain text-dashboardSub;\n}\n\n.values {\n  @apply text-secondary text-dashboardSub font-h4 font-inter flex justify-start pl-6 mt-[4px];\n}\n\n.fullLabel {\n  @apply flex items-center gap-2;\n}\n\n.button {\n  @apply row-span-4 flex gap-3 justify-end items-start;\n}\n\n.clearButton {\n  @apply bg-white text-secondary border-secondary w-[155px] h-[38px];\n}\n\n.clearButton:hover {\n  @apply !bg-white !text-secondary !border-secondary;\n}\n.viewTicket {\n  @apply bg-white text-secondary border-secondary w-[307px] h-[38px] text-dashboardMain font-dashboardMain font-inter;\n}\n\n.viewTicket:hover {\n  @apply !bg-white !text-secondary !border-secondary;\n}\n\n.buttonGroup {\n  @apply flex flex-col gap-4;\n}\n.firstGroupButton {\n  @apply flex gap-4;\n}\n.lastGroupButton {\n  @apply flex;\n}\n\n.downloanImageBox {\n  @apply rounded-[5px] w-[34px] h-[34px] flex justify-center items-center ml-2;\n  background: linear-gradient(144.9deg, #ffdb52 8.6%, rgba(229, 198, 80, 0.8) 94.03%);\n}\n\n.downloanIcon {\n  @apply w-[17px] h-[9px];\n}\n.warningText {\n  @apply text-warningTextColor font-dashboardMain text-dashboardSub font-inter ml-3;\n}\n\n.warningCard {\n  @apply h-[47px] bg-warningCardBG rounded-[5px] mt-2 flex items-center mb-3 ml-3 mr-3;\n}\n\n.tableWrapper :global(.ant-checkbox .ant-checkbox-inner) {\n  @apply !border-gray-400 w-[15px] h-[15px] rounded-[2px];\n}\n\n.tableWrapper :global(.ant-checkbox-checked .ant-checkbox-inner) {\n  @apply !bg-primary !border-primary;\n}\n\n.evenRow td {\n  @apply bg-white;\n}\n\n.oddRow td {\n  @apply bg-tableEvenRowBG;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `V6kqVURPCnKS2j7oXi08`,
	"customBreadCrumbs": `af8377lwdouyOo9HQKqM`,
	"mainContainer": `vFwd2tnWJ9kNyImRHvWX`,
	"applyButton": `c0Hz9RemSyVqussyKmPo`,
	"tenantRightActions": `l0nNehz8gPOui64N_7qD`,
	"searchInput": `POkiSSI91a4o5rv3A38c`,
	"tableWrapper": `JNh3uQRhHxuO5SNdmXjZ`,
	"pledgeCell": `aEeN3TmAkztXRyDtYVDr`,
	"pledgeText": `BIsw3Kux1YPtgyGsMsq0`,
	"ant-table-tbody": `uJWEs1otNuabutPlA9Cg`,
	"expandableBG": `OQ0nHGHng7obodw6AYNP`,
	"totalItems": `CwbMTs6OBfBgKFWt0ReJ`,
	"months": `ug32bByvZNqVTEBtoIgw`,
	"expandIcon": `JqkMb1ZYlJMEsJoTpYx3`,
	"labelTitle": `NWXaRPHs74mlOsl10EU5`,
	"values": `E_qdv4KedeLgpWMZYeiU`,
	"fullLabel": `KW7mAh8S9Jj717FAvP_G`,
	"button": `WPeUsqKg4dlCzQo6fUWv`,
	"clearButton": `io6NlK_61tlQsEtRQX_k`,
	"viewTicket": `vC9fVHiSNpAfMtzUBKZC`,
	"buttonGroup": `AKCfW0xDvXvTYqCw49iW`,
	"firstGroupButton": `GAf3mUFppDUrYdSBsvea`,
	"lastGroupButton": `Mbx93k024o_ACg_nuzGL`,
	"downloanImageBox": `RsbZTNNBWU_5SqW5yIjg`,
	"downloanIcon": `ol91iuiAO8oFsgdujg9l`,
	"warningText": `A2W498rE2tcc3ctfoTsn`,
	"warningCard": `tWRVEaUUcUThjqCy7YOn`,
	"evenRow": `tKjeIQfCgzWMy400s48k`,
	"oddRow": `qFJSYWNfC7j7n98Rbzty`
};
export default ___CSS_LOADER_EXPORT___;
